// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qc-8";
export var editMode = "_qc-3";
export var headerRow = "_qc-a";
export var headerTitle = "_qc-b";
export var product = "_qc-1";
export var productDetails = "_qc-5";
export var productDivider = "_qc-7";
export var productImage = "_qc-2";
export var productInfo = "_qc-4";
export var productTitle = "_qc-6";
export var strikethrough = "_qc-9";
export var upsellProductsCard = "_qc-0";